/**
 * CRM case "subject" tree (incident.subjectid). GUIDs are solution-deployed, identical in DM and prod.
 * ponytail: hardcoded so titles can be localized; re-sync when CRM subjects change.
 */
type SupportSubject = Readonly<{
  id: string;
  parentId?: string;
  /** English CRM title, also written to incident.gaming_subjectdetails. */
  title: string;
  stringKey: string;
}>;

const accountManagement = "4ff6d24c-550f-4a16-8b00-015e6f279764";
const royaltiesAndPayments = "b19a1d49-5ece-f111-a05c-0022483163eb";
const titleTransfer = "e21a6fbc-5ece-f111-a05c-0022483163eb";
const certification = "e7f22b45-e1a7-f111-aaac-7c1e52010a11";
const cfrManagement = "f342c13e-5fce-f111-a05c-0022483163eb";
const development = "f8dd0b55-e1a7-f111-aaac-7c1e52010a11";
const discounting = "ad927d6b-e1a7-f111-aaac-7c1e52010a11";
const events = "3f584273-e1a7-f111-aaac-7c1e52010a11";
const gameConcepts = "c456223f-e1a7-f111-aaac-7c1e52010a11";
const marketing = "e5a3ea62-e1a7-f111-aaac-7c1e52010a11";
const onboarding = "6da1b60a-6295-e911-a985-000d3a1be436";
const nda = "306d3de4-67ce-f111-a05c-0022483163eb";
const partnerCenter = "0705cb95-a7c0-e911-a993-000d3a1beaae";
const problemsLoggingIn = "eb4eb2b7-e1a7-f111-aaac-7c1e52010a11";
const programs = "da572698-68ce-f111-a05c-0022483163eb";
const pitches = "9fba2da1-68ce-f111-a05c-0022483163eb";

export const supportSubjects: ReadonlyArray<SupportSubject> = [
  {
    id: accountManagement,
    title: "Account Management",
    stringKey: "hubSupportSubjectAccountManagement",
  },
  {
    id: "6e592136-5ece-f111-a05c-0022483163eb",
    parentId: accountManagement,
    title: "Business Information Changes",
    stringKey: "hubSupportSubjectBusinessInfoChanges",
  },
  {
    id: "f710c2e7-5ece-f111-a05c-0022483163eb",
    parentId: accountManagement,
    title: "Game Insights / Analytics",
    stringKey: "hubSupportSubjectGameInsights",
  },
  {
    id: royaltiesAndPayments,
    parentId: accountManagement,
    title: "Royalties & Payments",
    stringKey: "hubSupportSubjectRoyaltiesPayments",
  },
  {
    id: "db68fa76-5ece-f111-a05c-0022483163eb",
    parentId: royaltiesAndPayments,
    title: "Earnings Blank in Partner Center",
    stringKey: "hubSupportSubjectEarningsBlank",
  },
  {
    id: "f8da4d93-5ece-f111-a05c-0022483163eb",
    parentId: royaltiesAndPayments,
    title: "Payee & Vendor ID Setup",
    stringKey: "hubSupportSubjectPayeeVendorSetup",
  },
  {
    id: "1b9b2459-5ece-f111-a05c-0022483163eb",
    parentId: royaltiesAndPayments,
    title: "Payments Not Received",
    stringKey: "hubSupportSubjectPaymentsNotReceived",
  },
  {
    id: "c4e6cea1-5ece-f111-a05c-0022483163eb",
    parentId: royaltiesAndPayments,
    title: "Royalties Statement Portal",
    stringKey: "hubSupportSubjectRoyaltiesStatementPortal",
  },
  {
    id: "3471e386-5ece-f111-a05c-0022483163eb",
    parentId: royaltiesAndPayments,
    title: "Royalty Profile Activation / Reactivation",
    stringKey: "hubSupportSubjectRoyaltyProfileActivation",
  },
  {
    id: "82ea996b-5ece-f111-a05c-0022483163eb",
    parentId: royaltiesAndPayments,
    title: "Statements vs Insights — understanding my numbers",
    stringKey: "hubSupportSubjectStatementsVsInsights",
  },
  {
    id: titleTransfer,
    parentId: accountManagement,
    title: "Title / Game & TLA Transfer",
    stringKey: "hubSupportSubjectTitleTransfer",
  },
  {
    id: "88f9abd4-5ece-f111-a05c-0022483163eb",
    parentId: titleTransfer,
    title: "Product Reparenting / Account Move",
    stringKey: "hubSupportSubjectProductReparenting",
  },
  { id: certification, title: "Certification", stringKey: "hubSupportSubjectCertification" },
  {
    id: cfrManagement,
    parentId: certification,
    title: "CFR Management",
    stringKey: "hubSupportSubjectCfrManagement",
  },
  {
    id: "684df154-5fce-f111-a05c-0022483163eb",
    parentId: cfrManagement,
    title: "CFR Issuance",
    stringKey: "hubSupportSubjectCfrIssuance",
  },
  {
    id: "674d1d60-5fce-f111-a05c-0022483163eb",
    parentId: cfrManagement,
    title: "CFR Resolution",
    stringKey: "hubSupportSubjectCfrResolution",
  },
  {
    id: "ee36b3fc-5ece-f111-a05c-0022483163eb",
    parentId: certification,
    title: "PreCert Readiness (Store Listings / PDP)",
    stringKey: "hubSupportSubjectPreCertReadiness",
  },
  {
    id: "97823814-5fce-f111-a05c-0022483163eb",
    parentId: certification,
    title: "Pricing & Availability",
    stringKey: "hubSupportSubjectPricingAvailability",
  },
  {
    id: "c5f2c32e-5fce-f111-a05c-0022483163eb",
    parentId: certification,
    title: "Ratings & Compliance",
    stringKey: "hubSupportSubjectRatingsCompliance",
  },
  {
    id: "b140104a-5fce-f111-a05c-0022483163eb",
    parentId: certification,
    title: "Release Checklist",
    stringKey: "hubSupportSubjectReleaseChecklist",
  },
  {
    id: "74ba861d-5fce-f111-a05c-0022483163eb",
    parentId: certification,
    title: "Submission Evaluation",
    stringKey: "hubSupportSubjectSubmissionEvaluation",
  },
  { id: development, title: "Development", stringKey: "hubSupportSubjectDevelopment" },
  {
    id: "d764877e-5fce-f111-a05c-0022483163eb",
    parentId: development,
    title: "Dev Kits & GDK Access",
    stringKey: "hubSupportSubjectDevKitsGdk",
  },
  {
    id: "a297040f-67ce-f111-a05c-0022483163eb",
    parentId: development,
    title: "Dev Mode Activation",
    stringKey: "hubSupportSubjectDevModeActivation",
  },
  {
    id: "9b2af519-67ce-f111-a05c-0022483163eb",
    parentId: development,
    title: "Service Configuration & XBOX Live Services",
    stringKey: "hubSupportSubjectServiceConfiguration",
  },
  {
    id: "3056a432-67ce-f111-a05c-0022483163eb",
    parentId: development,
    title: "Submission Validator (SubVal)",
    stringKey: "hubSupportSubjectSubmissionValidator",
  },
  { id: discounting, title: "Discounting", stringKey: "hubSupportSubjectDiscounting" },
  { id: events, title: "Events", stringKey: "hubSupportSubjectEvents" },
  { id: gameConcepts, title: "Game Concepts", stringKey: "hubSupportSubjectGameConcepts" },
  {
    id: "aba70f59-67ce-f111-a05c-0022483163eb",
    parentId: gameConcepts,
    title: "Concept Approval Status",
    stringKey: "hubSupportSubjectConceptApprovalStatus",
  },
  {
    id: "df5e7f9b-67ce-f111-a05c-0022483163eb",
    parentId: gameConcepts,
    title: "Questions about the Concept Form",
    stringKey: "hubSupportSubjectConceptFormQuestions",
  },
  {
    id: "8fbd2bb0-67ce-f111-a05c-0022483163eb",
    parentId: gameConcepts,
    title: "Revisions Required",
    stringKey: "hubSupportSubjectRevisionsRequired",
  },
  { id: marketing, title: "Marketing", stringKey: "hubSupportSubjectMarketing" },
  { id: onboarding, title: "Onboarding", stringKey: "hubSupportSubjectOnboarding" },
  {
    id: "48733fdc-67ce-f111-a05c-0022483163eb",
    parentId: onboarding,
    title: "Application & Registration Status",
    stringKey: "hubSupportSubjectApplicationStatus",
  },
  {
    id: "13721acf-67ce-f111-a05c-0022483163eb",
    parentId: onboarding,
    title: "Eligibility",
    stringKey: "hubSupportSubjectEligibility",
  },
  { id: nda, parentId: onboarding, title: "NDA", stringKey: "hubSupportSubjectNda" },
  {
    id: "8cab5f05-68ce-f111-a05c-0022483163eb",
    parentId: nda,
    title: "NDA Country/Region Correction",
    stringKey: "hubSupportSubjectNdaCountryCorrection",
  },
  {
    id: "100dcbf1-67ce-f111-a05c-0022483163eb",
    parentId: nda,
    title: "NDA Not Received",
    stringKey: "hubSupportSubjectNdaNotReceived",
  },
  {
    id: "5689e8fb-67ce-f111-a05c-0022483163eb",
    parentId: nda,
    title: "NDA Signing Problem",
    stringKey: "hubSupportSubjectNdaSigningProblem",
  },
  {
    id: "76b68a1e-68ce-f111-a05c-0022483163eb",
    parentId: onboarding,
    title: "TLA / MSA Agreements",
    stringKey: "hubSupportSubjectTlaMsaAgreements",
  },
  { id: partnerCenter, title: "Partner Center", stringKey: "hubSupportSubjectPartnerCenter" },
  {
    id: "b4ba4045-68ce-f111-a05c-0022483163eb",
    parentId: partnerCenter,
    title: "Entra ID & User Management",
    stringKey: "hubSupportSubjectEntraUserManagement",
  },
  {
    id: "5d3fe48e-e1a7-f111-aaac-7c1e52010a11",
    parentId: partnerCenter,
    title: "PC Verification Failed",
    stringKey: "hubSupportSubjectPcVerificationFailed",
  },
  {
    id: problemsLoggingIn,
    title: "Problems Logging In",
    stringKey: "hubSupportSubjectProblemsLoggingIn",
  },
  {
    id: "10632a28-e2a7-f111-aaac-7c1e52010a11",
    parentId: problemsLoggingIn,
    title: "Entertainment Development Store - Access Problems",
    stringKey: "hubSupportSubjectEdsAccess",
  },
  {
    id: "e889a3cf-e1a7-f111-aaac-7c1e52010a11",
    parentId: problemsLoggingIn,
    title: "Partner Center - Access Problems",
    stringKey: "hubSupportSubjectPartnerCenterAccess",
  },
  {
    id: "f84d541b-e2a7-f111-aaac-7c1e52010a11",
    parentId: problemsLoggingIn,
    title: "Royalties Portal - Access Problems",
    stringKey: "hubSupportSubjectRoyaltiesPortalAccess",
  },
  {
    id: "63b0150a-e2a7-f111-aaac-7c1e52010a11",
    parentId: problemsLoggingIn,
    title: "SupplierWeb - Access Problems",
    stringKey: "hubSupportSubjectSupplierWebAccess",
  },
  {
    id: "aa2150c6-e1a7-f111-aaac-7c1e52010a11",
    parentId: problemsLoggingIn,
    title: "XBOX Developer Hub - Access Problems",
    stringKey: "hubSupportSubjectDeveloperHubAccess",
  },
  { id: programs, title: "Programs", stringKey: "hubSupportSubjectPrograms" },
  {
    id: "94ed54bc-68ce-f111-a05c-0022483163eb",
    parentId: programs,
    title: "Game Preview (Xbox Early Access)",
    stringKey: "hubSupportSubjectGamePreview",
  },
  { id: pitches, parentId: programs, title: "Pitches", stringKey: "hubSupportSubjectPitches" },
  {
    id: "586b39ad-68ce-f111-a05c-0022483163eb",
    parentId: pitches,
    title: "Pitch Review Status",
    stringKey: "hubSupportSubjectPitchReviewStatus",
  },
  {
    id: "6f4955b6-68ce-f111-a05c-0022483163eb",
    parentId: programs,
    title: "XPA Incentive",
    stringKey: "hubSupportSubjectXpaIncentive",
  },
];

export const getSupportSubject = (id: string | undefined) =>
  id ? supportSubjects.find(subject => subject.id === id.toLowerCase()) : undefined;

/** Root-first ancestry of a subject, including itself; empty when unknown. */
export const getSupportSubjectPath = (id: string | undefined): ReadonlyArray<SupportSubject> => {
  const subject = getSupportSubject(id);
  return subject ? [...getSupportSubjectPath(subject.parentId), subject] : [];
};

/** Legacy hub categories (still drafted by the support assistant) mapped onto subjects. */
export const legacyCategorySubjectIds: Readonly<Record<string, string>> = {
  accountSetup: accountManagement,
  gameConcept: gameConcepts,
  development,
  certification,
  royalties: royaltiesAndPayments,
  marketing,
  sales: discounting,
  events,
};
